function Products() {
    return (
        <div />
    );
}

export default Products;